import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "flowbite";
import $ from 'jquery/src/jquery';
import debounce from 'lodash/debounce';

Rails.start()
Turbolinks.start()
ActiveStorage.start()

$(document).on('turbolinks:load', function() {
  initializeFlowbite();
  setupSearchFormSubmission();
  setupArticleVisitTracking();
  setupJobVisitTracking();
  setupAdClickTracking();
  scrollToHighlightedNews();
  setupNewsletterSubscription();
  setupNewsletterPopUpModal();
  setupPaginationLinks();
  clampHPBodyText();
});

// Global variables to track reCAPTCHA status
window.hasSubscribeNewsletterFormRecaptchaPassed = false;
window.hasSubscribeNewsletterModalFormRecaptchaPassed = false;

function toggleSubmitButton(didCheckPass, submitButton, form="") {
  if (!submitButton) return;

  let canSubmit;

  if (form == "subscribe_newsletter_form") {
    const weeklyCheckbox = document.querySelector("#subscribe_weekly_newsletter");
    const dailyCheckbox = document.querySelector("#subscribe_daily_newsletter");

    if (!weeklyCheckbox || !dailyCheckbox) return;

    const isAnyChecked = weeklyCheckbox.checked || dailyCheckbox.checked;
    canSubmit = isAnyChecked && didCheckPass;
  } else if (form == "subscribe_newsletter_modal_form") {
    const weeklyCheckbox = document.querySelector("#subscribe_weekly_newsletter_modal_checkbox");
    const dailyCheckbox = document.querySelector("#subscribe_daily_newsletter_modal_checkbox");

    if (!weeklyCheckbox || !dailyCheckbox) return;

    const isAnyChecked = weeklyCheckbox.checked || dailyCheckbox.checked;
    canSubmit = isAnyChecked && didCheckPass;
  } else {
    canSubmit = didCheckPass;
  }

  submitButton.disabled = !canSubmit;
  submitButton.classList.toggle("bg-gray-400", !canSubmit);
  submitButton.classList.toggle("cursor-not-allowed", !canSubmit);
  submitButton.classList.toggle("bg-[#ed2c34]", canSubmit);
  submitButton.classList.toggle("hover:bg-[#e12d2b]", canSubmit);
  submitButton.classList.toggle("cursor-pointer", canSubmit);
}

function enableContactUsFormSubmitButton() {
  const submitButton = document.getElementById('contact_form_submit_btn');
  toggleSubmitButton(true, submitButton);
}

function disableContactUsFormSubmitButton() {
  const submitButton = document.getElementById('contact_form_submit_btn');
  toggleSubmitButton(false, submitButton);
}

function enableSubscribeNewsletterModalSubmitButton() {
  const submitButton = document.getElementById('subscribe_newsletter_modal_btn');
  window.hasSubscribeNewsletterModalFormRecaptchaPassed = true;

  toggleSubmitButton(true, submitButton, "subscribe_newsletter_modal_form");
}

function disableSubscribeNewsletterModalSubmitButton() {
  const submitButton = document.getElementById('subscribe_newsletter_modal_btn');
  window.hasSubscribeNewsletterModalFormRecaptchaPassed = false;

  toggleSubmitButton(false, submitButton, "subscribe_newsletter_modal_form");
}

function enableSubscribeNewsletterWidgetSubmitButton() {
  const submitButton = document.getElementById('subscribe_newsletter_widget_btn');
  window.hasSubscribeNewsletterWidgetFormRecaptchaPassed = true;

  toggleSubmitButton(true, submitButton, "subscribe_newsletter_widget_form");
}

function disableSubscribeNewsletterWidgetSubmitButton() {
  const submitButton = document.getElementById('subscribe_newsletter_widget_btn');
  window.hasSubscribeNewsletterWidgetFormRecaptchaPassed = false;

  toggleSubmitButton(false, submitButton, "subscribe_newsletter_widget_form");
}

function enableNewsletterFormSubmitButton() {
  const submitButton = document.getElementById('subscribe_newsletter_form_submit_btn');
  window.hasSubscribeNewsletterFormRecaptchaPassed = true;

  toggleSubmitButton(true, submitButton, "subscribe_newsletter_form");
}

function disableNewsletterFormSubmitButton() {
  const submitButton = document.getElementById('subscribe_newsletter_form_submit_btn');
  window.hasSubscribeNewsletterFormRecaptchaPassed = false;

  toggleSubmitButton(false, submitButton, "subscribe_newsletter_form");
}

function enableNewsTipFormSubmitButton() {
  const submitButton = document.getElementById('newstip_form_submit_btn');
  toggleSubmitButton(true, submitButton);
}

function disableNewsTipFormSubmitButton() {
  const submitButton = document.getElementById('newstip_form_submit_btn');
  toggleSubmitButton(false, submitButton);
}

window.nativeShare = function(btn) {
  const url = btn.dataset.shareUrl;
  const title = btn.dataset.shareTitle || '';
  if (navigator.share) {
    navigator.share({ url: url, title: title }).catch(function() {});
  } else {
    showLinkCopiedToast(url);
  }
};

window.copyShareLink = function(btn) {
  showLinkCopiedToast(btn.dataset.shareUrl);
};

function showLinkCopiedToast(url) {
  if (!(navigator.clipboard && navigator.clipboard.writeText)) {
    window.prompt('Copy this link:', url);
    return;
  }

  navigator.clipboard.writeText(url).then(function() {
    var t = document.getElementById('link-copied');
    if (!t) return;
    t.classList.remove('hidden');
    setTimeout(function() { t.classList.add('hidden'); }, 2000);
  }).catch(function() {});
}

// Make functions globally available to reCAPTCHA
window.enableContactUsFormSubmitButtonWrapper = enableContactUsFormSubmitButton;
window.disableContactUsFormSubmitButtonWrapper = disableContactUsFormSubmitButton;

window.enableSubscribeNewsletterModalSubmitButtonWrapper = enableSubscribeNewsletterModalSubmitButton;
window.disableSubscribeNewsletterModalSubmitButtonWrapper = disableSubscribeNewsletterModalSubmitButton;

window.enableSubscribeNewsletterWidgetSubmitButtonWrapper = enableSubscribeNewsletterWidgetSubmitButton;
window.disableSubscribeNewsletterWidgetSubmitButtonWrapper = disableSubscribeNewsletterWidgetSubmitButton;

window.enableNewsletterFormSubmitButtonWrapper = enableNewsletterFormSubmitButton;
window.disableNewsletterFormSubmitButtonWrapper = disableNewsletterFormSubmitButton;

window.enableNewsTipFormSubmitButtonWrapper = enableNewsTipFormSubmitButton;
window.disableNewsTipFormSubmitButtonWrapper = disableNewsTipFormSubmitButton;

// Function to initialize Flowbite
function initializeFlowbite() {
  if (typeof window.initFlowbite === "function") {
    window.initFlowbite();
    console.log("Flowbite initialized successfully.");
  } else {
    console.error("Flowbite initialization function is missing.");
  }
}

// Function to handle search form submission
function setupSearchFormSubmission() {
  const searchInput = $('#default-search');
  // Prevent duplicate event listeners using `off().on()`

  searchInput.off('change').on('change', function () {
    $(this).closest('form').trigger('submit.rails');
  });

  searchInput.off('input').on('input', debounce(function () {
    if ($(this).val() === '') {
      $(this).closest('form').trigger('submit.rails');
    }
  }, 300));
}


function setupArticleVisitTracking() {
  // Prevent duplicate event listeners using `off().on()`
  $(document).off('click', 'a[data-article-id]').on('click', 'a[data-article-id]', function (event) {
    event.preventDefault();

    const articleId = $(this).data('article-id');
    const url = $(this).attr('href');

    window.open(url, '_blank');

    // Send the tracking request after opening the link.
    // TODO We may replace this with `navigator.sendBeacon()` later for better reliability.
    $.ajax({
      url: `/articles/${articleId}/increment_visit_count`,
      type: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function () {
        // window.open(url, '_blank'); // Redirect after incrementing clicks
      },
      error: function (xhr) {
        console.error('Error:', xhr.responseText);
        // TODO Possible Future Improvement: Retry later using `localStorage` or `sendBeacon()`
      }
    });
  });
}

// Function to handle job visit tracking on page load
function setupJobVisitTracking() {
  // Track job page views (not external link clicks)
  const jobShowPage = document.querySelector('[data-job-show-page]');
  if (jobShowPage) {
    const jobId = jobShowPage.dataset.jobId;
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    const url = `/jobs/${jobId}/increment_visit_count`;

    // Use sendBeacon for non-blocking, reliable tracking
    if (navigator.sendBeacon) {
      const formData = new FormData();
      formData.append('authenticity_token', csrfToken);
      navigator.sendBeacon(url, formData);
    } else {
      // Fallback to fetch with keepalive for older browsers
      fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json'
        },
        keepalive: true
      }).catch(err => console.error('Visit tracking error:', err));
    }
  }

  // External job links use native browser behavior (target="_blank")
  // No need to intercept clicks - this preserves cmd/ctrl-click, context menu, etc.
}

// Function to handle advertisement click tracking
function setupAdClickTracking() {
  document.querySelectorAll('.carousel-image-link').forEach(link => {
    // Prevent duplicate event listeners using `removeEventListener`
    link.removeEventListener('click', handleAdClick);
    link.addEventListener('click', handleAdClick);
  });
}

function handleAdClick(event) {
  event.preventDefault();
  const imageId = this.dataset.id;
  window.open(this.href, '_blank', 'noopener,noreferrer');

  fetch(`/ad_images/${imageId}/increment_clicks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    credentials: 'same-origin'
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      console.log(`Click count for image ${imageId}: ${data.clicks_count}`);
    }
  })
  .catch(error => console.error('Error:', error));
}

// Function to scroll to highlighted news on page load
function scrollToHighlightedNews() {
  // Scrolling smoothly to the highlighted article on page load
  const highlightedElements = document.querySelectorAll(".highlighted-news");

  if (highlightedElements.length > 0) {
    highlightedElements[0].scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

function toggleButtonState(weeklyCheckbox, dailyCheckbox, subscribeButton, form="") {
  if (!weeklyCheckbox || !dailyCheckbox || !subscribeButton) return;

  const isAnyChecked = weeklyCheckbox.checked || dailyCheckbox.checked;

  let canSubmit;

  if (form == "subscribe_newsletter_form") {
    const hasRecaptchaPassed = window.hasSubscribeNewsletterFormRecaptchaPassed;
    canSubmit = isAnyChecked && hasRecaptchaPassed;
  } else if (form == "subscribe_newsletter_modal_form") {
    const hasRecaptchaPassed = window.hasSubscribeNewsletterModalFormRecaptchaPassed;
    canSubmit = isAnyChecked && hasRecaptchaPassed;
  } else {
    canSubmit = isAnyChecked;
  }

  subscribeButton.disabled = !canSubmit;
  subscribeButton.classList.toggle("bg-gray-400", !canSubmit);
  subscribeButton.classList.toggle("cursor-not-allowed", !canSubmit);
  subscribeButton.classList.toggle("bg-[#ed2c34]", canSubmit);
  subscribeButton.classList.toggle("hover:bg-[#e12d2b]", canSubmit);
  subscribeButton.classList.toggle("cursor-pointer", canSubmit);
}

// Named functions for event listeners
function handleNewsletterCheckboxChange() {
  const weeklyCheckbox = document.querySelector("#subscribe_weekly_newsletter");
  const dailyCheckbox = document.querySelector("#subscribe_daily_newsletter");
  const subscribeButton = document.querySelector("#subscribe_newsletter_form_submit_btn");
  toggleButtonState(weeklyCheckbox, dailyCheckbox, subscribeButton, "subscribe_newsletter_form");
}

// Function to handle newsletter subscription toggle
function setupNewsletterSubscription() {
  const weeklyCheckbox = document.querySelector("#subscribe_weekly_newsletter");
  const dailyCheckbox = document.querySelector("#subscribe_daily_newsletter");
  const subscribeButton = document.querySelector("#subscribe_newsletter_form_submit_btn");

  if (!weeklyCheckbox || !dailyCheckbox || !subscribeButton) return;

  // Remove old event listeners using named function
  weeklyCheckbox.removeEventListener("change", handleNewsletterCheckboxChange);
  dailyCheckbox.removeEventListener("change", handleNewsletterCheckboxChange);

  // Add new event listeners
  weeklyCheckbox.addEventListener("change", handleNewsletterCheckboxChange);
  dailyCheckbox.addEventListener("change", handleNewsletterCheckboxChange);

  // Initial check on page load
  toggleButtonState(weeklyCheckbox, dailyCheckbox, subscribeButton, "subscribe_newsletter_form");
}

// Named functions for event listeners
function handleNewsletterModalCheckboxChange() {
  const weeklyCheckbox = document.querySelector("#subscribe_weekly_newsletter_modal_checkbox");
  const dailyCheckbox = document.querySelector("#subscribe_daily_newsletter_modal_checkbox");
  const subscribeButton = document.querySelector("#subscribe_newsletter_modal_btn");
  toggleButtonState(weeklyCheckbox, dailyCheckbox, subscribeButton, "subscribe_newsletter_modal_form");
}

function setupNewsletterSubscriptionInPopUpModal() {
  const weeklyModalCheckbox = document.querySelector("#subscribe_weekly_newsletter_modal_checkbox");
  const dailyModalCheckbox = document.querySelector("#subscribe_daily_newsletter_modal_checkbox");
  const subscribeModalButton = document.querySelector("#subscribe_newsletter_modal_btn");

  if (!weeklyModalCheckbox || !dailyModalCheckbox || !subscribeModalButton) return;

  // Prevent duplicate event listeners
  weeklyModalCheckbox.removeEventListener("change", handleNewsletterModalCheckboxChange);
  dailyModalCheckbox.removeEventListener("change", handleNewsletterModalCheckboxChange);

  weeklyModalCheckbox.addEventListener("change", handleNewsletterModalCheckboxChange);
  dailyModalCheckbox.addEventListener("change", handleNewsletterModalCheckboxChange);

  // Initial check on page load
  toggleButtonState(weeklyModalCheckbox, dailyModalCheckbox, subscribeModalButton, "subscribe_newsletter_modal_form");
}

// Display newsletter subscription pop-up modal
function setupNewsletterPopUpModal() {
  const newsletterPopUpModal = document.getElementById('newsletter-popup');
  const modalContent = document.getElementById('modal-content');
  const closeModalButton = document.getElementById('close-modal');

  if (!newsletterPopUpModal || !modalContent || !closeModalButton) return;

  const hasSubscribed = localStorage.getItem('newsletterSubscribed') === 'true';
  const wasShownInSession = sessionStorage.getItem('newsletterModalShown') === 'true';
  const showModal = () => {
    if (!hasSubscribed && !wasShownInSession) {
      sessionStorage.setItem('newsletterModalShown', 'true');
      setTimeout(() => {
        newsletterPopUpModal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
          modalContent.style.transform = 'translateY(0)';
        }, 10);
      }, 1000);
    }
  };
  showModal();
  function closeModal(hasSubscribed = false) {
    if (hasSubscribed) {
      localStorage.setItem('newsletterSubscribed', 'true');
    }
    modalContent.style.transform = 'translateY(100%)';
    setTimeout(() => {
      newsletterPopUpModal.classList.add('hidden');
      document.body.style.overflow = '';
      modalContent.style.transform = 'translateY(100%)';
    }, 300);
  }

  closeModalButton.addEventListener('click', () => closeModal(false));
  newsletterPopUpModal.addEventListener('click', function(e) {
    if (e.target === newsletterPopUpModal) {
      closeModal(false);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !newsletterPopUpModal.classList.contains('hidden')) {
      closeModal(false);
    }
  });

  const form = document.getElementById('newsletter-popup-form');
  if (form) {
    form.addEventListener('submit', function() {
      closeModal(true);
    });
  }

  // Initialize newsletter subscription logic separately
  setupNewsletterSubscriptionInPopUpModal();
}

function clampHPBodyText() {
  document.querySelectorAll('.hp-post').forEach(function(post) {
    var bodyEl = post.querySelector('.hp-excerpt');
    var titleEl = post.querySelector('.news-body');
    var imageEl = post.querySelector('.hp-thumb');

    if (!bodyEl || !imageEl) return;

    function applyClamp() {
      var imgHeight = imageEl.getBoundingClientRect().height;
      if (!imgHeight) return;

      var titleHeight = titleEl ? titleEl.getBoundingClientRect().height : 0;
      var availableHeight = imgHeight - titleHeight;

      if (availableHeight <= 0) {
        bodyEl.style.display = 'none';
        return;
      }

      var lineHeight = parseFloat(window.getComputedStyle(bodyEl).lineHeight) || 20;
      var lines = Math.max(3, Math.floor(availableHeight / lineHeight));

      bodyEl.style.overflow = 'hidden';
      bodyEl.style.display = '-webkit-box';
      bodyEl.style.webkitBoxOrient = 'vertical';
      bodyEl.style.webkitLineClamp = String(lines);
    }

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function(entries) {
        if (entries[0].contentRect.height > 0) {
          ro.disconnect();
          requestAnimationFrame(applyClamp);
        }
      });
      ro.observe(imageEl);
    } else {
      if (imageEl.complete && imageEl.naturalHeight > 0) {
        requestAnimationFrame(function() { requestAnimationFrame(applyClamp); });
      } else {
        imageEl.addEventListener('load', function() {
          requestAnimationFrame(applyClamp);
        }, { once: true });
      }
    }
  });
}

function setupPaginationLinks() {
  document.querySelectorAll('.pagination-news a').forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();

      const url = this.href;
      const urlObj = new URL(url);

      // Remove the article parameter to keep the URL clean.
      urlObj.searchParams.delete('article');

      // Use Turbolinks to visit the new URL.
      Turbolinks.visit(urlObj.href);
    });
  });
}
